import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';
import StickyCard from './StickyCard';
import useStickyCard from '../hooks/useStickyCard';
import { MINIMUM_VEHICLES } from '../global-constants';

const StickyCardContainer = ({ compareItemWidth }) => {
	const vehicles = useSelector((state) => state.vehicles);
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';

	useStickyCard(isMobile, compareItemWidth);

	return (
		<div className="overflow-hidden sticky-card-container">
			<div
				className="d-flex mx-auto"
				// Subtracting 10px to account for the right margin on each card except the last one
				style={{
					width: `${vehicles.length * compareItemWidth - 10}px`
				}}
			>
				{vehicles.map((vehicle) => {
					return (
						<StickyCard
							vehicle={vehicle}
							cardWidth={compareItemWidth}
							showRemoveButton={
								vehicles.length > MINIMUM_VEHICLES
							}
							key={`sticky-card-${vehicle.uuid}`}
						/>
					);
				})}
			</div>
		</div>
	);
};

StickyCardContainer.propTypes = {
	compareItemWidth: PropTypes.number.isRequired
};
export default StickyCardContainer;
